// Modal.tsx
import React from "react";

export interface ModalProps {
  open: boolean;
  title: string;
  message?: string;
  onClose: () => void;
  children?: React.ReactNode;
  fullScreen?: boolean; // ✅ Optional prop to make modal full-screen
}

const Modal: React.FC<ModalProps> = ({
  open,
  title,
  message,
  onClose,
  children,
  fullScreen = false,
}) => {
  if (!open) return null;

  return (
    <div className={`fixed inset-0 z-50 bg-black/50 flex items-center justify-center ${fullScreen ? "print:static print:block print:bg-transparent" : ""}`}>
      <div
        className={`
          bg-white shadow rounded
          max-w-[90vw]
print:overflow-visible
print:h-auto
          ${fullScreen ? "w-[95vw] max-h-[95vh] overflow-y-auto print:w-full print:max-w-none print:max-h-none print:overflow-visible print:shadow-none print:rounded-none" : ""}
        `}
      >
        {title && (
          <h2 className="text-lg font-bold p-4 border-b">{title}</h2>
        )}

        <div className={fullScreen ? "p-4 print:p-0" : "p-4"}>
          {message && <p className="mb-4">{message}</p>}
          {children}
        </div>

        <div className={fullScreen ? "fixed right-4 top-4 z-[60] print:hidden" : "p-4 border-t flex justify-end print:hidden"}>
          <button
            type="button"
            onClick={onClose}
            className={fullScreen ? "rounded-full border border-gray-300 bg-white px-4 py-2 font-semibold text-gray-800 shadow-lg hover:bg-gray-100 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-primary" : "px-4 py-2 bg-gray-300 rounded hover:bg-gray-400"}
          >
            Close
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
